import challenge from '../img/pdf/challenge-led.png';
import cocrear from '../img/pdf/cocrear-futuros.png';
import cocreation from '../img/pdf/co-creation.png';
import xcurve from '../img/pdf/x-curve.png';

import challengePdf from '../pdf/1-Challenge-Led-System-Mapping_compressed.pdf';
import cocrearPdf from '../pdf/2-Co-crear futuros sostenibles.pdf';
import cocreationPdf from '../pdf/3-Co-creation for policy.pdf';
import xcurvePdf from '../pdf/4-XCurve.pdf';

const manualData = [
  {
    nombre: 'Challenge-led System Mapping',
    logo: challenge,
    pdf: challengePdf,
    autor: 'coautor',
    archivo:
      'challenge-led-system-mapping.pdf',
  },

  {
    nombre: 'Cocrear futuros sostenibles',
    logo: cocrear,
    pdf: cocrearPdf,
    autor: 'coautor',
    archivo:
      'cocrear-futuros-sostenibles.pdf',
  },

  {
    nombre: 'Co-Creation for Policy',
    logo: cocreation,
    pdf: cocreationPdf,
    autor: 'contribuidor',
    archivo:
      'co-creation-for-policy.pdf',
  },

  {
    nombre: 'X-Curve',
    logo: xcurve,
    pdf: xcurvePdf,
    autor: 'contribuidor',
    archivo: 'x-curve.pdf',
  },
];

export default manualData;